import { render, staticRenderFns } from "./referrers-select.vue?vue&type=template&id=211a24c2"
import script from "./referrers-select.vue?vue&type=script&lang=ts"
export * from "./referrers-select.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports